import { render } from "./DescriptionGroup.vue?vue&type=template&id=0adb6feb"
import script from "./DescriptionGroup.vue?vue&type=script&lang=js"
export * from "./DescriptionGroup.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__